import { messageError, PageSection } from '@deltaohm/ant-components';
import {
  Alert,
  Col,
  Row,
  Typography,
  Result,
  Button,
} from 'antd';

import { useTranslation } from 'react-i18next';
import ErrorList from 'antd/lib/form/ErrorList';
import React from 'react';

import SerialPort from '../utils/serial';

const fetchInformation = async (serialPort) => {
  console.log('CMD:INSTR_ID:?\n');
  const serialNumber = await serialPort.writeStringWithResponseString('CMD:INSTR_ID:?\r\n', 3000, (data) => {
    console.log(data);
    if (data.startsWith('XPT800')) {
      const splitted = data.split(' ');
      console.log(splitted[1]);
      return splitted[1].trim();
    }
    return null;
  });
  console.log('CMD:PRE_ID:?\n');
  const preAmpliSerialNumber = await serialPort.writeStringWithResponseString('CMD:PRE_ID:?\r\n', 3000, (data) => {
    console.log(data);
    if (data.startsWith('MP800')) {
      const splitted = data.split(' ');
      console.log(splitted[1]);
      return splitted[1].trim();
    }
    return null;
  });

  console.log('CMD:MIC_ID:?\n');
  const micSerialNumber = await serialPort.writeStringWithResponseString('CMD:MIC_ID:?\r\n', 3000, (data) => {
    console.log(data);
    if (data.startsWith('MC800')) {
      const splitted = data.split(' ');
      console.log(splitted[1]);
      return splitted[1].trim();
    }
    return null;
  });

  if (!serialNumber || !preAmpliSerialNumber || !micSerialNumber) {
    return null;
  }

  return {
    serialNumber,
    preAmpliSerialNumber,
    micSerialNumber,
  };
};

const SoundMeterXPT800ManagePage = () => {
  const { t } = useTranslation();

  const [connectedSoundMeter, setConnectedSoundMeter] = React.useState(null);

  const handleConnectError = () => {
    messageError({
      content: (
        <>
          <Typography.Title level={5}>
            {t('localSoundMeters.manage.cannotConnect.title')}
          </Typography.Title>
          <ErrorList errors={[
            t('localSoundMeters.manage.cannotConnect.link'),
            t('localSoundMeters.manage.cannotConnect.port'),
            t('localSoundMeters.manage.cannotConnect.model'),
            t('localSoundMeters.manage.cannotConnect.usb'),
          ]}
          />
        </>
      ),
    });
  };

  const handleConnect = async () => {
    const port = await SerialPort.connect({
      baudRate: 230400,
      // flowControl: 'hardware',
      bufferSize: 1024,
    });

    const serialPort = new SerialPort(port);

    if (!serialPort) {
      throw new Error();
    }

    const result = await fetchInformation(serialPort);
    if (result) {
      setConnectedSoundMeter({
        data: result,
        serialPort,
      });
    }
    else {
      await serialPort.disconnect();
      handleConnectError();
    }
  };

  const renderConnect = () => {
    if (!SerialPort.isAvailable()) {
      return (
        <Row>
          <Col xs={24}>
            <Alert
              message={t('localSoundMeters.connect.serial')}
              description={t('localSoundMeters.connect.serialUnavailable')}
              type="error"
              showIcon
            />
          </Col>
        </Row>
      );
    }
    return (
      <Row>
        <Col xs={24}>
          <Result
            title={t('soundMeterXPT800.connect.infoTitle')}
            subTitle={t('soundMeterXPT800.connect.infoSubTitle')}
            extra={[
              <Button type="primary" key="connect" onClick={handleConnect}>
                {t('soundMeterXPT800.connect.connectButton')}
              </Button>,
            ]}
          />
        </Col>
      </Row>
    );
  };

  const renderContent = () => {
    const result = (
      <div>
        {JSON.stringify(connectedSoundMeter.data, null, 2)}
      </div>
    );
    return result;
  };

  return (
    <PageSection
      title={t('soundMeterXPT800.manage.title')}
      subtitle={t('soundMeterXPT800.manage.subtitle')}
    >
      {!connectedSoundMeter && renderConnect()}
      {connectedSoundMeter && renderContent()}
    </PageSection>
  );
};

export default SoundMeterXPT800ManagePage;
